import axios from 'axios'
import InputAsync from 'components/Inputs/InputAsync'
import debounce from 'debounce-promise'
import React, { useCallback } from 'react'
import { API_HOST } from '../../consts'

const SheetOrderStatus = ({
  params,
  ...props
}: {
  params?: any
  basic?: boolean
  name?: string
  label?: any
}) => {
  // eslint-disable-next-line
  const fetchSheetOrderStatus = useCallback(
    debounce(async (search) => {
      const response = await axios.get(`${API_HOST}/v1/sheet-order-status`, {
        params: {
          search,
          ...params
        }
      })
      return response.data
    }, 500),
    [params]
  )

  return (
    <InputAsync
      key={JSON.stringify(params)}
      defaultOptions
      loadOptions={fetchSheetOrderStatus}
      name="status"
      getOptionValue={(d) => d.id}
      getOptionLabel={(d) => d.name}
      {...props}
    />
  )
}

export default SheetOrderStatus
